import React from 'react'
import PropTypes from 'prop-types'

const lineStyle = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10,
}

const CrossCircleIcon = ({ customClassName, width, height, fill, line, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Plus Circle"
    viewBox="0 0 50 50"
  >
    <title id="cross-circle-icon">Cross Circle</title>
    <g>
      <circle fill={fill} cx="25" cy="25" r="25" />
      <polyline stroke={line} style={lineStyle} points="16,34 25,25 34,16 " />
      <polyline stroke={line} style={lineStyle} points="16,16 25,25 34,34 " />
    </g>
  </svg>)

CrossCircleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  line: PropTypes.string,
  customClassName: PropTypes.string,
}

CrossCircleIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'white',
  line: 'blue',
  customClassName: '',
}

export default CrossCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/CrossCircle.js